import { withStyles } from '@mui/styles';
import React from 'react';
import AbstractDialogTab from '../../base/dialog/components/web/AbstractDialogTab';
import { translate } from '../../base/i18n/functions';
import Slider from '../../base/ui/components/web/Slider';
import { inklusivaSettingsStyles } from '../ui-constants';
const styles = (theme) => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        },
        headline: {
            marginBottom: theme.spacing(3),
            fontSize: '0.875rem'
        },
        inputElement: {
            marginBottom: theme.spacing(1),
            fontWeight: 'bold'
        },
        textareaElement: {
            marginBottom: theme.spacing(1)
        },
        description: {
            marginBottom: theme.spacing(3),
            fontSize: '0.875rem'
        },
        ...inklusivaSettingsStyles(theme)
    };
};
class SignLangTranscriptionTab extends AbstractDialogTab {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { transcriptionActive, transcriptionFontSize, transcriptionHistory, classes, signLangDisplay, signLangWindowSize, t } = this.props;
        const getSizeDescription = (size) => t(`settings.uiSettings.fontSizes.size${size}`);
        const getLengthDescription = (size) => t(`settings.uiSettings.length.size${size}`);
        return (React.createElement("div", { className: classes.container },
            React.createElement("h2", null, t('settings.transcription.headline')),
            React.createElement("p", { className: 'mt-05' }, t('settings.transcription.intro')),
            React.createElement("h3", null, t('settings.transcription.headlineDisplay')),
            React.createElement("fieldset", null,
                React.createElement("legend", { "aria-hidden": 'true' }),
                React.createElement("div", { className: classes.controlContainer },
                    React.createElement("div", { className: [classes.controlColumn, classes.flexDirectionRow].join(' ') },
                        React.createElement("input", { checked: signLangDisplay === 'window', className: 'radio', id: 'opt1', name: 'display_radiogroup', onChange: event => super._onChange({
                                signLangDisplay: event.target.value
                            }), type: 'radio', value: 'window' }),
                        React.createElement("label", { className: classes.controlColumnLabel, htmlFor: 'opt1' }, t('settings.transcription.display_option1')))),
                React.createElement("div", { className: classes.controlContainer },
                    React.createElement("div", { className: [classes.controlColumn, classes.flexDirectionRow].join(' ') },
                        React.createElement("input", { checked: signLangDisplay === 'tile', className: 'radio', id: 'opt2', name: 'display_radiogroup', onChange: event => super._onChange({
                                signLangDisplay: event.target.value
                            }), type: 'radio', value: 'tile' }),
                        React.createElement("label", { className: classes.controlColumnLabel, htmlFor: 'opt2' }, t('settings.transcription.display_option2'))))),
            React.createElement("div", { className: [classes.controlContainer, 'mt-1'].join(' ') },
                React.createElement("div", { className: classes.controlColumn },
                    React.createElement(Slider, { className: classes.inputElement, defaultValue: signLangWindowSize, id: 'windowsize-slider', label: t('settings.transcription.windowsize_label'), max: 100, min: 0, onChange: event => super._onChange({
                            signLangWindowSize: event.target.value
                        }), step: 1 })),
                React.createElement("div", { className: classes.valueColumn },
                    signLangWindowSize,
                    "%"))));
    }
}
export default withStyles(styles)(translate(SignLangTranscriptionTab));
